import React from 'react'
import { useMarkingContext } from '../MarkingContext/MarkingContext'
import TableRowStudent from './TableRowStudent'
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LegendLevels from './LegendLevels'

const getMarkingIds = (list) => {
  const marking = []
  list?.forEach((student) => {
    student?.marking?.forEach((m) => {
      if (!marking.includes(m?.assessmentAreaId)) {
        marking.push(m?.assessmentAreaId)
      }
    })
  })
  return marking
}

const TableList = ({ list = [], rowsPerPage = 50, handleMenuOpen }) => {
  const {
    currentPeriodicalReport,
    previousPeriodicalReport,
    loading,
    isLoading,
    loadingSave,
    currentAssessmentArea,
    effortAndConductOptions
  } = useMarkingContext()
  const colSpan = currentPeriodicalReport?.previousPeriodicalReportId ? 7 : 4
  const styles = currentPeriodicalReport?.previousPeriodicalReportId ? { padding: '0 0.5rem' } : {}
  const markingIds = getMarkingIds(list)
  const assessmentAreasLevels = currentPeriodicalReport?.assessmentAreas.filter((area) =>
    markingIds.includes(area._id)
  )
  const assessmentAreasRatings = currentPeriodicalReport?.ratings

  const effortAndConductOps = currentPeriodicalReport.effortAndConductOptions.filter((option) =>
    option?.view.includes('by-assessment-area')
  )
  const assessmentArea = assessmentAreasLevels.find(
    (area) => area._id === currentAssessmentArea && area.assessmentData.levels.some((lvl) => lvl.definition)
  )
  const colSpanEC = effortAndConductOps?.length > 0 ? effortAndConductOps.length : 0
  const colSpanRatings = assessmentAreasRatings?.length > 0 ? 1 : 0

  return (
    <>
      {loadingSave && (
        <Box
          className='absolute inset-0 flex items-center justify-center bg-loading bg-opacity-90 z-20'
          style={{
            backdropFilter: 'blur(0.8px)'
          }}
        >
          <FontAwesomeIcon icon='circle-notch' spin size='2x' className='text-muted-foreground opacity-75' />
        </Box>
      )}
      <div className='absolute inset-0 flex gap-4'>
        <TableContainer className=' flex flex-col' component={Box}>
          <Table>
            <TableHead className='sticky top-0px z-10'>
              <TableRow>
                <TableCell
                  rowSpan={3}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  Students (#{list?.length || 0})
                </TableCell>
                {currentPeriodicalReport?.previousPeriodicalReportId && (
                  <TableCell
                    key={`periodical-assessment-area-group-prev`}
                    colSpan={3}
                    className='text-center'
                    style={{
                      outline: '1px solid var(--muted)',
                      background: 'rgb(230 234 239)',
                      ...styles
                    }}
                  >
                    <Typography variant='body2' className='font-bold'>
                      previous Assessment Area
                    </Typography>
                    <Typography variant='subtitle2' className='font-bold text-lg'>
                      {isLoading ? <Skeleton variant='text' /> : previousPeriodicalReport?.code}
                    </Typography>
                  </TableCell>
                )}
                <TableCell
                  key={`periodical-assessment-area-group-current`}
                  colSpan={3 + colSpanEC + colSpanRatings}
                  className='text-center'
                  style={{
                    padding: '0 0.5rem',
                    outline: '1px solid var(--muted)'
                  }}
                >
                  <Typography variant='body2' className='font-bold'>
                    current Assessment Area
                  </Typography>
                  <Typography variant='subtitle2' className='font-bold text-lg'>
                    {isLoading ? <Skeleton variant='text' /> : currentPeriodicalReport?.code}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                {currentPeriodicalReport?.previousPeriodicalReportId && (
                  <>
                    <TableCell
                      key={`period-assessment-area-code`}
                      className='text-center'
                      rowSpan={2}
                      width={80}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      code
                    </TableCell>
                    <TableCell
                      key={`period-assessment-area-name`}
                      className='text-center'
                      rowSpan={2}
                      width={150}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      name
                    </TableCell>
                    <TableCell
                      key={`period-previous-${currentPeriodicalReport?.previousPeriodicalReportId}`}
                      className='text-center'
                      rowSpan={2}
                      width={80}
                      style={{
                        outline: '1px solid var(--muted)',
                        background: 'rgb(230 234 239)'
                      }}
                    >
                      level
                    </TableCell>
                  </>
                )}
                <TableCell
                  key={`period-assessment-area-code`}
                  className='text-center'
                  rowSpan={2}
                  width={80}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  code
                </TableCell>
                <TableCell
                  key={`period-assessment-area-name`}
                  className='text-center'
                  rowSpan={2}
                  width={150}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  name
                </TableCell>
                <TableCell
                  key={`period-previous-${currentPeriodicalReport?.previousPeriodicalReportId}`}
                  className='text-center'
                  rowSpan={2}
                  width={80}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  level
                </TableCell>
                {assessmentAreasRatings?.length > 0 && (
                  <TableCell
                    rowSpan={2}
                    className='text-center'
                    width={150}
                    style={{
                      outline: '1px solid var(--muted)'
                    }}
                  >
                    Rating
                  </TableCell>
                )}
                {effortAndConductOps?.length > 0 && (
                  <TableCell
                    className='text-center'
                    colSpan={2}
                    style={{
                      outline: '1px solid var(--muted)'
                      // background: 'rgba(32, 0, 150, 0.05)'
                    }}
                  >
                    Effort and Conduct
                  </TableCell>
                )}
              </TableRow>
              {effortAndConductOps?.length > 0 &&
                effortAndConductOps?.map((option) => (
                  <TableCell
                    key={`period-effort-conduct-${option?.code}`}
                    className='text-center text-xs'
                    width={100}
                    style={{
                      outline: '1px solid var(--muted)',
                      lineHeight: 1
                      // background: 'rgba(32, 0, 150, 0.05)'
                    }}
                  >
                    {option?.name}
                  </TableCell>
                ))}
            </TableHead>
            <TableBody className='relative'>
              {list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={colSpan + colSpanEC + colSpanRatings} className='text-center'>
                    <Typography
                      color='inherit'
                      component={'p'}
                      className='text-muted-foreground opacity-50 py-2 text-center'
                    >
                      {" You don't have any students yet"}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                list?.map((row, index) => {
                  return (
                    <TableRowStudent
                      key={`student-${row.studentId}-${index}`}
                      row={row}
                      effortAndConductOptions={effortAndConductOptions}
                      showRating={assessmentAreasRatings?.length > 0}
                      showEffortAndConduct={effortAndConductOps?.length > 0}
                      rowMarking={row?.marking
                        .map((marking) => ({
                          ...marking,
                          code: marking?.assessmentArea?.code
                        }))
                        .sort((a, b) => a?.code - b?.code)}
                      handleMenuOpen={handleMenuOpen}
                      index={index}
                    />
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {assessmentArea && <LegendLevels assessmentArea={assessmentArea?.assessmentData} />}
      </div>
    </>
  )
}

export default React.memo(TableList)
